<template>
  <div class="column">
    <div class="title text-brand-5 text-weight-bold">Filtros</div>
    <section class="row">
      <div
        class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold filtro-unidade"
      >
        Unidade:
        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold filtro-ordenar"
      >
        Ordenar Por:

        <q-select :options="tipos" v-model="filtros.order" dense outlined />
      </div>

      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Grupo de Produto:
        <q-input dense outlined v-model="filtros.produto" />
      </div>

      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        <div class="texto-titulo-input">Saldo Estoque</div>
        <q-select
          v-model="filtros.saldo"
          dense
          outlined
          map-options
          emit-value
          option-value="value"
          option-label="label"
          :options="saldoOptions"
          class="select"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { watchDebounced } from "@vueuse/core";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useStore } from "vuex";
export default {
  components: { ListaUnidadesSelect },
  setup(props, { emit }) {
    const filtros = ref({
      produto: "",
      order: "",
      unidade: "",
      saldo: "",
    });
    const store = useStore();

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      filtros.value.unidade = store.state.org.unidadeData;
    };
    onMounted(getUnidade);

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );

    watchDebounced(
      [
        () => filtros.value.produto,
        () => filtros.value.order,
        () => filtros.value.unidade,
        () => filtros.value.saldo,
      ],
      () => {
        emit("emitirFiltros", filtros.value);
      },
      { debounce: 400 }
    );

    return {
      filtros,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },

      optionsFn(date) {
        var hoje = new Date();

        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        var data_ok = yyyy + "/" + mm + "/" + dd;

        return date <= data_ok;
      },
      tipos: [
        { label: "Ordem Alfabética (A-Z)", value: "alfa_asc" },
        { label: "Ordem Alfabética (Z-A)", value: "alfa_desc" },
        { label: "Menor Quantidade", value: "quant_asc" },
        { label: "Maior Quantidade", value: "quant_desc" },
        { label: "Menor Valor Total", value: "val_asc" },
        { label: "Maior Valor Total", value: "val_desc" },
      ],
      saldoOptions: [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ],
    };
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 15px;
  font-size: 1.25rem;
  margin-top: 20px;
}

@media (max-width: 600px) {
  .title {
    font-size: 1.2rem !important;
    text-align: center;
    margin-bottom: 16px;
  }

  .row {
    flex-direction: column !important;
  }

  .col-md-2 {
    width: 100% !important;
    margin: 0 0 16px 0 !important;
    padding: 0 !important;
  }

  .filtro-ordenar {
    margin-top: 10px !important;
  }

  .q-ml-sm {
    margin-left: 0 !important;
  }

  .col-md-2 .q-field {
    width: 100% !important;
  }

  .col-md-2 .q-select {
    width: 100% !important;
  }

  .col-md-2 .q-input {
    width: 100% !important;
  }
  .texto-titulo-input {
    margin-bottom: 5px;
  }
}
</style>

<style>
@media (max-width: 600px) {
  .filtro-unidade lista-unidades-select {
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .filtro-unidade lista-unidades-select * {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .filtro-unidade .mobileUnidade {
    margin-left: 0 !important;
  }
}
</style>
